<p-card>
  <ng-template pTemplate="title">
    <div class="bay-inventory-header">
      <span>Bay Inventory</span>
      <span class="bay-inventory-total">Total: {{ bayInventoryTotal | number:'1.0-0' }}</span>
    </div>
  </ng-template>
  <form>
    <div class="p-datatable p-component p-datatable-auto-layout p-datatable-responsive-stack">
      <div class="p-datatable-wrapper">
        <table class="p-datatable-table">
          <thead class="p-datatable-thead">
            <tr>
              <th>Bay</th>
              <th>Product<span class="required">*</span></th>
              <th>Length<span class="required">*</span></th>
              <th>X</th>
              <th>Width<span class="required">*</span></th>
              <th>X</th>
              <th>Height<span class="required">*</span></th>
              <th>Pieces<span class="required">*</span></th>
              <th>Total</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody class="p-element p-datatable-tbody">
            <ng-template ngFor let-item [ngForOf]="bayInventoryItems" let-ri="index" [ngForTrackBy]="rowTrackBy">
              <tr [formGroup]="item">
                <td>
                  <div class="centered">
                    {{item.controls.displayOrder.value}}
                  </div>
                </td>
                <td>
                  <p-dropdown #productId
                    [options]="products"
                    formControlName="product"
                    name="product"
                    [required]
                    [filter]="true"
                    [editable]="false"
                    [resetFilterOnHide]="true"
                    [tabindex]="ri*8+0"
                    appendTo="body">
                  </p-dropdown>
                </td>
                <td>
                  <input pInputText type="number" #dim1xId
                    formControlName="dim1x"
                    style="width:100%"
                    name="dim1x"
                    required
                    lib-numeric
                    [tabindex]="ri*8+1">
                </td>
                <td class="tdX">
                  <div class="centered">
                    X
                  </div>
                </td>
                <td>
                  <input pInputText type="number"
                    formControlName="dim1y"
                    style="width:100%"
                    name="dim1y"
                    required
                    lib-numeric
                    [tabindex]="ri*8+2">
                </td>
                <td class="tdX">
                  <div class="centered">
                    X
                  </div>
                </td>
                <td>
                  <input pInputText type="number"
                    formControlName="dim1z"
                    style="width:100%"
                    name="dim1z"
                    required
                    lib-numeric
                    [tabindex]="ri*8+3">
                </td>
                <td>
                  <input pInputText type="number" #piecesId
                    formControlName="pieces"
                    style="width:100%"
                    name="pieces"
                    required
                    lib-numeric
                    (change)="onChangeBayInventoryField(item)"
                    [tabindex]="ri*8+7">
                </td>
                <td class="tdX">
                  <div class="centered">
                    {{item.totalInventory | async}}
                  </div>
                </td>
                <td class="centered">
                  <confirmation-button
                    [iconsOnly]="true"
                    actionIcon="pi pi-times"
                    actionText="Delete"
                    confirmIcon="pi pi-times"
                    confirmText="Delete"
                    cancelIcon="pi pi-minus-circle"
                    cancelText="Cancel"
                    (actionConfirmed)="deleteBay(item)"
                    [disabled]="shiftClosed">
                  </confirmation-button>
                </td>
              </tr>
              <tr [formGroup]="item">
                <td [attr.colspan]="2"></td>
                <td>
                  <input pInputText type="number" #dim2xId
                    formControlName="dim2x"
                    style="width:100%"
                    name="dim2x"
                    required
                    lib-numeric
                    (change)="onChangeBayInventoryField(item)"
                    [tabindex]="ri*8+4">
                </td>
                <td class="tdX">
                  <div class="centered">
                    X
                  </div>
                </td>
                <td>
                  <input pInputText type="number"
                    formControlName="dim2y"
                    style="width:100%"
                    name="dim2y"
                    required
                    lib-numeric
                    (change)="onChangeBayInventoryField(item)"
                    [tabindex]="ri*8+5">
                </td>
                <td class="tdX">
                  <div class="centered">
                    X
                  </div>
                </td>
                <td>
                  <input pInputText type="number"
                    formControlName="dim2z"
                    style="width:100%"
                    name="dim2z"
                    required
                    lib-numeric
                    (change)="onChangeBayInventoryField(item)"
                    [tabindex]="ri*8+6">
                </td>
                <td [attr.colspan]="3"></td>
              </tr>
            </ng-template>
            <tr *ngIf="!bayInventoryItems || bayInventoryItems.length === 0">
              <td [attr.colspan]="10" class="centered">
                No data available
              </td>
            </tr>
          </tbody>
          <tfoot class="p-datatable-tfoot" [formGroup]="bayInventoryForm">
            <tr>
              <td class="tdX">
                <div class="centered">
                  {{nextBay}}
                </div>
              </td>
              <td>
                <p-dropdown [options]="products" [required] appendTo="body"
                  placeholder="-- Select Product --" [editable]="false" [filter]="true" class="form-control"
                  name="product" [resetFilterOnHide]="true" [tabindex]="bayInventoryItems.length*8" formControlName="product">
                </p-dropdown>
                <error-block [field]="bayInventoryForm.get('product')" [messages]="{
                  required: 'Product is required.'
                }">
                </error-block>
              </td>
              <td>
                <input type="number" lib-numeric pInputText id="dim1x" required name="dim1x" class="form-control"
                  [tabindex]="bayInventoryItems.length*8+1" formControlName="dim1x"/>
                <error-block [field]="bayInventoryForm.get('dim1x')" [messages]="{
                  required: 'Length is required.'
                }">
                </error-block>
              </td>
              <td class="tdX">
                <div class="centered">
                  X
                </div>
              </td>
              <td>
                <input type="number" lib-numeric pInputText id="dim1y" required name="dim1y" class="form-control"
                  [tabindex]="bayInventoryItems.length*8+2" formControlName="dim1y"/>
                <error-block [field]="bayInventoryForm.get('dim1y')" [messages]="{
                  required: 'Width is required.'
                }">
                </error-block>
              </td>
              <td class="tdX">
                <div class="centered">
                  X
                </div>
              </td>
              <td>
                <input type="number" lib-numeric pInputText id="dim1z" required name="dim1z" class="form-control"
                  [tabindex]="bayInventoryItems.length*8+3" formControlName="dim1z"/>
                <error-block [field]="bayInventoryForm.get('dim1y')" [messages]="{
                  required: 'Height is required.'
                }">
                </error-block>
              </td>
              <td>
                <input type="number" lib-numeric pInputText id="pieces" required name="pieces" class="form-control"
                  [tabindex]="bayInventoryItems.length*8+7" formControlName="pieces"/>
              </td>
              <td class="tdX">
                <div class="centered">
                  {{bayInventoryFormTotal}}
                </div>
              </td>
              <td>
                <button type="button" pButton
                  icon="pi pi-plus"
                  iconPos="left"
                  (click)="saveBI();"
                  label="Add"
                  [disabled]="bayInventoryForm.disabled"
                  [ngClass]="{ 'p-state-disabled': !bayInventoryForm.valid }"
                  [tabindex]="bayInventoryItems.length*8+8"></button>
              </td>
            </tr>
            <tr [formGroup]="bayInventoryForm">
              <td [attr.colspan]="2"></td>
              <td>
                <input type="number" lib-numeric pInputText id="dim2x" required name="dim2x" class="form-control" aria-label="Length"
                  [tabindex]="bayInventoryItems.length*8+4" formControlName="dim2x"/>
              </td>
              <td class="tdX">
                <div class="centered">
                  X
                </div>
              </td>
              <td>
                <input type="number" lib-numeric pInputText id="dim2y" required name="dim2y" class="form-control" aria-label="Width"
                  [tabindex]="bayInventoryItems.length*8+5" formControlName="dim2y"/>
              </td>
              <td class="tdX">
                <div class="centered">
                  X
                </div>
              </td>
              <td>
                <input type="number" lib-numeric pInputText id="dim2z" required name="dim2z" class="form-control" aria-label="Height"
                  [tabindex]="bayInventoryItems.length*8+6" formControlName="dim2z"/>
              </td>
              <td [attr.colspan]="3"></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </form>
</p-card>
